export const validatePassword = (password: string) => {
  const hasLength = password.length >= 12 && password.length <= 16;
  const hasLowerCase = /[a-z]/.test(password);
  const hasUpperCase = /[A-Z]/.test(password);
  const hasNumber = /[0-9]/.test(password);

  if (!hasLength || !hasLowerCase || !hasUpperCase || !hasNumber) {
    return {
      valid: false,
      error:
        "Password must contain 12-16 characters, at least 1 lowercase letter, 1 uppercase letter, and 1 number",
    };
  }
  return { valid: true, error: "" };
};

export const validateUsername = (username: string) => {
  if (!username.trim())
    return { valid: false, error: "Please enter a username" };
  return { valid: true, error: "" };
};

export const validateEmail = (email: string) => {
  if (!email.trim()) return { valid: false, error: "Please enter an email" };
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email))
    return { valid: false, error: "Please enter a valid email" };
  return { valid: true, error: "" };
};

export const validatePasswordMatch = (
  password: string,
  confirmPassword: string,
) => {
  if (password !== confirmPassword) {
    return { valid: false, error: "Passwords do not match" };
  }
  return { valid: true, error: "" };
};
